import React, { Dispatch, SetStateAction } from "react";

import { Box, Typography } from "@mui/material";

import { TStep } from "../TeamsIntegrationModal.types";
import { TeamsIntegrationModalFileListStep } from "../TeamsIntegrationModalFileListStep";
import { TeamsIntegrationModalMetadataStep } from "../TeamsIntegrationModalMetadataStep";
import { TeamsIntegrationReviewStep } from "../TeamsIntegrationReviewStep";

interface TeamsIntegrationModalContentProps {
  step: TStep;
  callbackClose: () => void;
  setSelectedChannel: Dispatch<
    SetStateAction<
      { drive_id: string; item_id: string; channelName: string; teamName: string } | undefined
    >
  >;
  selectedChannel:
    | { drive_id: string; item_id: string; channelName: string; teamName: string }
    | undefined;
  onLoadingChange: (_loading: boolean) => void;
}

export const TeamsIntegrationModalContent: React.FC<TeamsIntegrationModalContentProps> = ({
  step,
  callbackClose,
  setSelectedChannel,
  selectedChannel,
  onLoadingChange,
}) => {
  return (
    <>
      {step === "fileList" && (
        <TeamsIntegrationModalFileListStep
          callbackClose={callbackClose}
          setSelectedChannel={setSelectedChannel}
          selectedChannel={selectedChannel}
          onLoadingChange={onLoadingChange}
        />
      )}
      {step === "metadata" && <TeamsIntegrationModalMetadataStep />}
      {step === "review" && <TeamsIntegrationReviewStep />}
      {step === "warning" && (
        <Box data-testid="warning-content">
          <Typography fontSize="14px">
            Importing Teams item(s) will <strong>override</strong> previously imported Teams
            item(s).
          </Typography>
          <Typography fontSize="14px">
            Importing can be time consuming and costly so, we encourage teams to{" "}
            <strong>limit it to 4 times a month.</strong>
          </Typography>
          <Typography fontSize="14px">
            You have imported the Teams item(s) <strong>2/4</strong> times this month. Do you still
            want to import item(s)?
          </Typography>
        </Box>
      )}
    </>
  );
};
